import { render, staticRenderFns } from "./not-authorize.vue?vue&type=template&id=eb63787a&scoped=true"
import script from "./not-authorize.vue?vue&type=script&lang=js"
export * from "./not-authorize.vue?vue&type=script&lang=js"
import style0 from "./not-authorize.vue?vue&type=style&index=0&id=eb63787a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb63787a",
  null
  
)

export default component.exports